import AvatarImg from "../../components/ui/AvatarImg";

// Thin wrapper — keeps the previous room-local API (name/size) while
// delegating rendering to the shared AvatarImg so we pick up the real
// uploaded picture + service-worker cache automatically.
export default function Avatar({ name, size = 38, avatarId = "" }) {
  return <AvatarImg name={name} size={size} avatarId={avatarId} />;
}
